import { Button, Heading, Modal, Paragraph } from '@zillow/constellation-10';

import IntermediateStep from '../../IntermediateStep';

interface PremiumMidfunnelSuccessModalProps {
  onClose: () => void;
  isActive?: boolean;
}

const PremiumMidfunnelSuccessModal = ({ onClose, isActive = false }: PremiumMidfunnelSuccessModalProps) => {
  return (
    <Modal
      data-testid="PremiumMidfunnelSuccessModal"
      open={true}
      onOpenChange={(open) => !open && onClose()}
      size={{ base: 'fullScreen', lg: 'md' }}
      header={<Heading level={1}>Upgrade to premium</Heading>}
      body={
        <IntermediateStep headingLevel={3} headingText="You’ve successfully upgraded to a premium listing!">
          <Paragraph>
            You now have access to premium features, including pricing strategy insights and recommendations for making
            your listing even stronger.
            {!isActive && (
              <>
                <br />
                <br /> Next, finalize and publish your listing so you can start reaching prospective renters.
              </>
            )}
          </Paragraph>
        </IntermediateStep>
      }
      footer={
        <Button size="md" tone="brand" emphasis="filled" onClick={onClose}>
          {isActive ? 'Got it' : 'Continue editing'}
        </Button>
      }
    />
  );
};

export default PremiumMidfunnelSuccessModal;
